export default "__VITE_ASSET__CnlwjI2U__"